import { render } from "./cart-section.vue?vue&type=template&id=06f3a406"
import script from "./cart-section.vue?vue&type=script&lang=js"
export * from "./cart-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__